import { Button, ProductBoxes, Spacer, InfoDialog } from 'components';
import { getHtml } from 'utils/componentsCommon';
import { Routes } from 'utils/routes';
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useRouter } from 'next/router';
import { useProducts } from 'utils/products';
import { ProductCategoriesEnum } from 'utils/enums';
import useAuthentication from 'utils/useAuthentication';
import getConfig from 'next/config';
import { initializePensionCheckResult } from 'utils/PensionCheck/pensionCheck';
import { useSelector, useDispatch } from 'react-redux';
import { fetchFiles } from 'store/actions/file';
import ProductBox from '../ProductBox';


const ProductBoxContainer = ({ affiliateId, productsToShow }) => {
    const router = useRouter();
    const { publicRuntimeConfig } = getConfig();
    const [currentPackage, setCurrentPackage] = useState();
    const products = useProducts(affiliateId, productsToShow);
    const [productCategory] = useState(ProductCategoriesEnum.Featured);
    const { authenticated } = useAuthentication();
    const [pensionCheckResult, setPensionCheckResult] = useState({});
    const [showNoPensionCheckDialog, setShowNoPensionCheckDialog] = useState(false);
    const suggestions = useSelector((state) => state.calculations.pensionAnalysis.suggestions);
    const { fetched, error } = useSelector((state) => state.scrapeData);
    const { isCalculating, calculated } = useSelector((state) => state.calculations);
    const dispatch = useDispatch();

    useEffect(() => {
        if (!fetched && authenticated) {
            dispatch(fetchFiles());
        }
    }, [fetched, dispatch, authenticated]);
    useEffect(() => {
        if(authenticated){
            setPensionCheckResult(initializePensionCheckResult(suggestions, error, calculated, isCalculating));

        }
    }, [suggestions, error, calculated, isCalculating, authenticated]);

    const flowDescriptions = {
        'economy-advisory-full': [
            'Opret en gratis profil på penly.dk.',
            'Klik på ‘Book rådgivning’.',
            'Vælg ’ØkonomiTjek’ og udfyld informationerne om din økonomi. Send data til rådgiveren.',
            'Book første møde i rådgiverens kalender.',
        ],
        'pension-advisory-pensioncheck': [
            'Opret en profil på penly.dk og hent dine pensionsoplysninger fra PensionsInfo.',
            'Se den digitale analyse af din pension med fokus på muligheder for forbedring.',
            'Bestil 15 min. gratis gennemgang af dit pensionstjek med en uvildig rådgiver.',
        ],
        'pension-advisory-full': [
            'Opret en gratis profil på penly.dk.',
            'Overfør dine pensionsdata med NemID og se den digitale analyse af din pension.',
            'Bestil &quot;Fuld rådgivning&quot; ved at udfylde formularen, så bliver du kontaktet af en uvildig rådgiver.',
        ],
        'pension-advisory-hourlyrate': [
            'Opret en profil på penly.dk og hent dine pensionsoplysninger fra PensionsInfo.',
            'Se den digitale analyse af din pension med fokus på muligheder for optimering.',
            'Bestil pensionsrådgivning på timebasis.',
        ],
    };
    const closeNoPensionCheckDialog = () => setShowNoPensionCheckDialog(false);
    const getAffiliateProductsFromCategory = () => {
        const affiliateProducts = Object.values(products)
            .filter(x => authenticated ? x.id != 'free-profile' : x)
            .filter((p) => !p.hidden && p.categories.find((c) => c === productCategory.id))
            .sort((a, b) => (a.price.standard || a.price.now || a.price.yearly?.standard * 20 || 0) * (a.price.hourly ? 4 : 1)  - (b.price.standard || b.price.now || b.price.yearly?.standard * 20 || 0) * (b.price.hourly ? 4 : 1) );
        console.log('affiliateProducts',affiliateProducts);
        console.log('products',products);
        return affiliateProducts;
    };
    const gotoDashboard = () => {
        router.push(Routes.MyPenly.Pension.Dashboard);
    };
    const handleChooseProduct = (_, product) =>{
        if (publicRuntimeConfig.featurePensionCheckNewOrderFlow && product.id === 'penly-subscription') {
            router.push(Routes.Advisory.PenlySubscription.Flow);
            return;
        }
        if (product.id === 'invest-advisory-full') {
            router.push(Routes.InvestCheck.LandingPage);
            return;
        }
        if(authenticated){
            if (product.id === 'pension-advisory-full') {
                router.push(Routes.Advisory.Nedsparing.Flow);
                return;
            }
            if (publicRuntimeConfig.featurePensionCheckNewOrderFlow && product.id === 'pension-advisory-pensioncheck') {
                if(!pensionCheckResult?.hasPensionCheck){
                    setShowNoPensionCheckDialog(true);
                    return;
                }
                router.push(Routes.Advisory.PensionCheck.Flow);
                return;
            }
            if (product.id === 'economy-advisory-full') {
                router.push(Routes.Advisory.EconomyCheck.Flow);
                return;
            }
            if (publicRuntimeConfig.featurePensionCheckNewOrderFlow && product.id === 'pension-advisory-hourlyrate') {
                router.push(Routes.Advisory.PensionAdvice.Flow);
                return;
            }
            router.push(Routes.MyPenly.Advisory.Product.Flow(product));
            return;
        }
        // eslint-disable-next-line no-nested-ternary
        product.id === 'free-profile'
            ? router.push(Routes.CreateProfile())
            : product.id === 'pension-advisory-full'
                ? router.push(Routes.Advisory.Nedsparing.Flow)
                : product.id === 'economy-advisory-full'
                    ? router.push(Routes.Advisory.EconomyCheck.Flow)
                    : setCurrentPackage(product.id);
    };


    return (
        <>
            { products && (
                <>
                    <article>
                        <section>
                            <ProductBoxes
                                products={ getAffiliateProductsFromCategory() }
                                chooseProductFunc={ handleChooseProduct
                                }
                                chooseProductText="Se mere"
                            ></ProductBoxes>
                            <Spacer />
                        </section>
                    </article>
                    { currentPackage && (
                        <div className="modalOverlay" onClick={ () => setCurrentPackage() }>
                            <div className="infoDialog pricesProductInfoDialog">
                                <div>
                                    <div className="inner">
                                        { currentPackage === 'economy-advisory-full' && (
                                            <>
                                                <h4>Få overblik over økonomien</h4>
                                                <h6>Sådan bestiller du et ØkonomiTjek:</h6>
                                            </>
                                        ) }
                                        { currentPackage && (
                                            <>
                                                <ol>
                                                    { flowDescriptions[currentPackage]?.map((step, i) => (
                                                        <li key={ i } dangerouslySetInnerHTML={ getHtml(step) } />
                                                    )) }
                                                </ol>
                                                <div className="buttons">
                                                    <Button onClick={ () => router.push(Routes.CreateProfile()) }>Opret profil nu</Button>
                                                </div>
                                            </>
                                        ) }
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) }
                </>
            ) }
            { showNoPensionCheckDialog && (
                <>
                    <InfoDialog
                        marker="?"
                        modal={ true }
                        onClose={ closeNoPensionCheckDialog }
                        modalContent={
                            <>
                                <h4>PensionsTjek mangler</h4>
                                <p>For at fortsætte skal du først lave et PensionsTjek ved at hente dine pensionsoplysninger fra PensionsInfo.dk på Start siden.</p>
                                <br />
                                <div className="buttonGroup">
                                    <Button size="small" onClick={ () => gotoDashboard() }>
                                        Gå til Start siden
                                    </Button>
                                </div>
                            </>
                        }
                    />
                </>
            ) }
        </>
    );
};

ProductBox.propTypes = {
    products: PropTypes.object.isRequired,
    currentPackage: PropTypes.object,
};

export default ProductBoxContainer;
